

























































import { Vue, Component } from 'vue-property-decorator';
import { SHOW_SNACKBAR } from '../../common/constants';
import { eventBus } from '../../main';
import brandModule from '../../store/modules/brand.module';
import { TagPayload } from '../../common/write.types';
import tagModule from '../../store/modules/tag.module';
import errorModule from '../../store/modules/error.module';

@Component({
  components: {},
})
export default class AdminCreateTag extends Vue {
  showNewTagDialog = false;

  isUniversal = false;

  tag: TagPayload = {
    title: '',
    brand_id: '',
  }

  tagDescription = 'Tags allow you to make your assets and products more organized and maintainable. For example, a tag could be a campaign, product line, region, etc.';


  async createNewTag(): Promise<void> {
    if (!brandModule.brand) { return; }
    if (this.tag.title.length < 2) {
      eventBus.$emit(
        SHOW_SNACKBAR,
        'Tag cannot be blank or one character.',
      );
      return;
    }
    if (!this.isUniversal) {
      this.tag.brand_id = brandModule.brand.id;
    }
    await tagModule.createTag(this.tag);
    if (errorModule.hasError) {
      errorModule.clearError();
      return;
    }
    eventBus.$emit(
      SHOW_SNACKBAR,
      'Successfully created the tag. You could now choose it from the tag menu.',
    );
    this.showNewTagDialog = false;
  }
}
